import React from "react"

function IconPlus({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="plus"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-plus"
      {...props}
    >
      <path
        d="M12 3.71c.325 0 .595.236.646.547l.009.107v6.98l6.981.001a.655.655 0 0 1 .107 1.301l-.107.009-6.981-.002v6.983a.655.655 0 0 1-1.301.107l-.009-.107v-6.983l-6.981.002a.655.655 0 0 1-.107-1.301l.107-.009h6.981V4.363c0-.362.294-.655.655-.655z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconPlus
